<template> <!-- OK -->
    <div class="user-list-container">
      <h2>Lista de Usuários</h2>
      <div class="button-group">
        <button @click="goBack" class="back-button">Voltar para Administração</button>
        <button @click="makeAllUsersPlayers" class="make-players-button">Tornar Todos Usuários Jogadores</button>
      </div>
      <div class="filter-container">
        <label for="sortOrder">Ordenar por:</label>
        <select v-model="sortOrder" @change="sortUsers" id="sortOrder">
          <option value="asc">Nome (A-Z)</option>
          <option value="desc">Nome (Z-A)</option>
        </select>
      </div>
      <div class="table-wrapper">
        <table class="user-table">
          <thead>
            <tr>
              <th>Nome de Usuário</th>
              <th>Telefone</th>
              <th>Admin</th>
              <th>Jogador</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in sortedUsers" :key="user.id">
              <td>{{ user.fullName }}</td>
              <td>{{ user.phone }}</td>
              <td>
                <input type="checkbox" :checked="user.isAdmin" @click="confirmToggleAdmin(user, $event)">
              </td>
              <td>
                <input type="checkbox" :checked="isPlayer(user.id)" @click="confirmTogglePlayer(user.id, $event)">
              </td>
              <td>
                <button @click="confirmDeleteUser(user.id)" class="delete-button">Deletar</button>
                <button @click="resetPassword(user.id)" class="resetPassword-button">Resetar Senha</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  import userService from '../services/userService';
  import playerService from '../services/playerService';
  
  export default {
    name: 'UserManagement',
    data() {
      return {
        users: [],
        players: [],
        sortOrder: 'asc',
      };
    },
    methods: {
      async fetchUsers() {
        try {
          const response = await userService.getAllUsers();
          this.users = response.data;
        } catch (error) {
          console.error('Erro ao buscar usuários', error);
        }
      },
      async fetchPlayers() {
        try {
          const response = await playerService.getAllPlayers();
          this.players = response.data;
        } catch (error) {
          console.error('Erro ao buscar jogadores', error);
        }
      },
      async toggleAdmin(user) {
        try {
          const updatedAdminStatus = !user.isAdmin;
          await userService.toggleAdmin(user.id, updatedAdminStatus);
          user.isAdmin = updatedAdminStatus;
        } catch (error) {
          console.error('Erro ao alterar o status', error);
        }
      },
      isPlayer(userId) {
        return this.players.some(player => player.userId === userId);
      },
      async togglePlayer(userId) {
        try {
          await playerService.togglePlayerStatus(userId);
          await this.fetchPlayers();
        } catch (error) {
          console.error('Erro ao alterar o status de jogador', error);
        }
      },
      async deleteUser(userId) {
        try {
          await userService.deleteUser(userId);
          await this.fetchUsers();
        } catch (error) {
          console.error('Erro ao deletar usuário:', error);
        }
      },
      async resetarSenha(userId) {
        try{
          await userService.resetPassword(userId);
        } catch (error) {
          console.error('Erro ao resetar senha', error);
        }
      },
      async makeAllUsersPlayers() {
        try {
          await userService.makeAllUsersPlayers();
          alert('Todos os usuários foram transformados em jogadores com sucesso!');
          await this.fetchUsers();
        } catch (error) {
          console.error('Erro ao tornar todos os usuários jogadores.', error);
          alert('Ocorreu um erro ao tentar transformar todos os usuários em jogadores.');
        }
      },
      goBack() {
        this.$router.push('/admin');
      },
      sortUsers() {
        this.sortedUsers;
      },
      confirmToggleAdmin(user, event) {
        if (confirm(`Você tem certeza que deseja alterar o status de admin para ${user.username}?`)) {
          this.toggleAdmin(user);
        } else {
          event.preventDefault();
        }
      },
      confirmTogglePlayer(userId, event) {
        const user = this.users.find(user => user.id === userId);
        if (confirm(`Você tem certeza que deseja alterar o status de jogador para ${user.username}?`)) {
          this.togglePlayer(userId);
        } else {
          event.preventDefault();
        }
      },
      confirmDeleteUser(userId) {
        const user = this.users.find(user => user.id === userId);
        if (confirm(`Você tem certeza que deseja deletar o usuário ${user.username}?`)) {
          this.deleteUser(userId);
        }
      },
      resetPassword(userId){
        const user = this.users.find(user => user.id === userId);
        if (confirm(`Você tem certeza que deseja resetar a senha do usuário ${user.username}?`)) {
          this.resetarSenha(userId);
        }
      }
    },
    created() {
      this.fetchUsers();
      this.fetchPlayers();
    },
    computed: {
      sortedUsers() {
        return this.users.slice().sort((a, b) => {
          if (this.sortOrder === 'asc') {
            return a.username.localeCompare(b.username);
          } else {
            return b.username.localeCompare(a.username);
          }
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .user-list-container {
    max-width: 1200px;
    margin: auto;
    padding: 2rem;
    background-color: #F9F9F9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .user-list-container h2 {
    text-align: center;
    margin-bottom: 1rem;
  }

  .button-group{
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    justify-content: center;
  }
  
  .back-button, .make-players-button {
    padding: 0.5rem 1rem;
    background-color: #0056B3;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .back-button:hover {
    background-color: #007BFF;
  }
  
  .filter-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
  }
  
  .filter-container label {
    margin-right: 0.5rem;
    font-weight: bold;
  }
  
  .filter-container select {
    padding: 0.5rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  
  .table-wrapper {
    overflow-x: auto;
  }
  
  .user-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .user-table th,
  .user-table td {
    border: 1px solid #DDD;
    padding: 0.75rem;
    text-align: center;
  }
  
  .user-table th {
    background-color: #0056B3;
    color: white;
  }
  
  .delete-button {
    padding: 0.5rem;
    background-color: #FF4136;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .delete-button:hover {
    background-color: #E62A2A;
  }

  .resetPassword-button {
    padding: 0.5rem;
    background-color: #2c7806;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 0.5rem;
  }

  .resetPassword-button:hover {
    background-color: #4acf07;
  }
  
  @media (max-width: 768px) {
    .user-list-container {
      padding: 1rem;
    }
  
    .user-table th,
    .user-table td {
      padding: 0.5rem;
      font-size: 0.9rem;
    }
  
    .back-button {
      font-size: 0.9rem;
      padding: 0.4rem 0.8rem;
    }
  }
  
  @media (max-width: 425px) {
    .user-list-container {
      padding: 0.5rem;
    }
  
    .user-table th,
    .user-table td {
      padding: 0.3rem;
      font-size: 0.8rem;
    }
  
    .back-button {
      font-size: 0.8rem;
      padding: 0.3rem 0.6rem;
    }
  
    .filter-container {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .filter-container label {
      margin-bottom: 0.5rem;
    }
  }
  </style>
  